// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-user-profile {
  position: fixed;
  top: 98px;
  right: 0;
  left: 0;
  bottom: 0;
  max-width: 100%;
  height: auto;
  max-height: calc(100% - 98px);
  background-color: rgb(233, 231, 222);
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  padding: 20px 10px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.popup-user-profile__heading {
  text-align: center;
  margin: 0;
}

.popup-user-profile__form {
  max-width: 80vw;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.popup-user-profile__form-profile {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.popup-user-profile__form input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: rgb(75, 70, 70);
  line-height: 16px;
  border-style: none;
  background-color: rgb(233, 231, 222);
}

.popup-user-profile__form input:focus {
  outline: none;
}

.popup-user-profile__form label {
  width: 30vw;
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(122,148,90);
  border-radius: 5px;
  font-size: 10px;
  padding: 3px 10px 0;
}

.popup-user-profile__button {
  padding: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.popup-user-profile__button:hover {
  opacity: .8;
}

.popup-user-profile__button_green {
  background: rgb(122,148,90);
  color: white;
  border-radius: 5px;
}

@media screen and (max-width: 910px) {
  .popup-user-profile {
    top: 92px;
  }

  .popup-user-profile__form {
    max-width: 100vw;
  }

  .popup-user-profile__form label {
    width: 80vw;
  }

  .popup-user-profile__form-profile {
    flex-direction: column;
  }
}

@media screen and (max-width: 520px) {
  .popup-user-profile {
    top: 79px;
  }
  
  .popup-user-profile__form label {
    width: 90vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PopupUserProfile.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,OAAO;EACP,SAAS;EACT,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".popup-user-profile {\r\n  position: fixed;\r\n  top: 98px;\r\n  right: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  max-width: 100%;\r\n  height: auto;\r\n  max-height: calc(100% - 98px);\r\n  background-color: rgb(233, 231, 222);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  align-items: center;\r\n  padding: 20px 10px;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n.popup-user-profile__heading {\r\n  text-align: center;\r\n  margin: 0;\r\n}\r\n\r\n.popup-user-profile__form {\r\n  max-width: 80vw;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.popup-user-profile__form-profile {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n}\r\n\r\n.popup-user-profile__form input {\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  font-size: 16px;\r\n  color: rgb(75, 70, 70);\r\n  line-height: 16px;\r\n  border-style: none;\r\n  background-color: rgb(233, 231, 222);\r\n}\r\n\r\n.popup-user-profile__form input:focus {\r\n  outline: none;\r\n}\r\n\r\n.popup-user-profile__form label {\r\n  width: 30vw;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid rgb(122,148,90);\r\n  border-radius: 5px;\r\n  font-size: 10px;\r\n  padding: 3px 10px 0;\r\n}\r\n\r\n.popup-user-profile__button {\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  font-size: 16px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.popup-user-profile__button:hover {\r\n  opacity: .8;\r\n}\r\n\r\n.popup-user-profile__button_green {\r\n  background: rgb(122,148,90);\r\n  color: white;\r\n  border-radius: 5px;\r\n}\r\n\r\n@media screen and (max-width: 910px) {\r\n  .popup-user-profile {\r\n    top: 92px;\r\n  }\r\n\r\n  .popup-user-profile__form {\r\n    max-width: 100vw;\r\n  }\r\n\r\n  .popup-user-profile__form label {\r\n    width: 80vw;\r\n  }\r\n\r\n  .popup-user-profile__form-profile {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .popup-user-profile {\r\n    top: 79px;\r\n  }\r\n  \r\n  .popup-user-profile__form label {\r\n    width: 90vw;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
